$(document).ready(() => {
    const updateTitleHeight = () => {
        let titleHeight = $(".levels-of-our-process-section .levels-of-our-process-row .title-wrap .title").outerHeight(true);
        $(".levels-of-our-process-section .levels-of-our-process-row .col-right").css("--title-height", `${titleHeight}px`);
    };

    // Initial call
    updateTitleHeight();

    // Update on window resize
    $(window).on("resize", updateTitleHeight);
});
